import { BUILDINGS_QUERY_KEY } from '@domain/buildings';
import { UseMutation, useMutationWrapper } from '@hooks/useMutationWrapper';
import { publishBuilding } from '@services/buildings/buildingsService';
import { useQueryClient } from 'react-query';

const usePublishBuilding = (
  venueId: string
): UseMutation<void, Error, string, unknown> => {
  const queryClient = useQueryClient();

  return useMutationWrapper<void, Error, string>(
    (buildingId) => publishBuilding(buildingId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(BUILDINGS_QUERY_KEY(venueId));
      }
    }
  );
};

export { usePublishBuilding };
